export const showPopup = (value, payload = {}) => {
  return (dispatch) => {
    dispatch({ type: "SET_POPUP_DATA", payload });
    dispatch({ type: "SHOW_POPUP", payload: value });
    dispatch({ type: "SET_SHOW_TOP_SECTIONS", payload: false });
  };
};
